export class B2FileInfo {
    readonly playlistName: string;

    readonly albumName: string;

    readonly fileNameWithoutExtension: string;

    constructor(readonly filePath: string) {
        const url = new URL(filePath);
        const pathName = decodeURIComponent(url.pathname);
        const parts = pathName.split(`/`);
        this.playlistName = parts[parts.length - 3];
        this.albumName = parts[parts.length - 2];
        const fileName = parts[parts.length - 1];
        this.fileNameWithoutExtension = fileName.replace(".mp3", "");
    }
}
